import { StyleSheet } from "react-native-web";
import { isClient } from "@tamagui/core";
import { Fragment, jsx, jsxs } from "react/jsx-runtime";
const ServerSideStyles = ({
  tamaguiCSS
}) => {
  if (isClient) return null;
  const rnwStyle = StyleSheet.getSheet();
  return /* @__PURE__ */jsxs(Fragment, {
    children: [/* @__PURE__ */jsx("style", {
      id: rnwStyle.id,
      dangerouslySetInnerHTML: {
        __html: rnwStyle.textContent
      }
    }), /* @__PURE__ */jsx("style", {
      dangerouslySetInnerHTML: {
        __html: tamaguiCSS
      }
    })]
  });
};
export { ServerSideStyles };